<app-tab-layout [loading]="loading()" [error]="error">
  @if (initialized()) {
    <div class="visit-legend" [attr.aria-label]="dictionaryService.get('VisitsLegend')">
      <span class="legend-title">{{ dictionaryService.get('Visits') }}</span>

      <span class="legend-item">
        <span class="legend-dot single" aria-hidden="true"></span>
        {{ dictionaryService.get('Single Visit') }}
      </span>

      <span class="legend-item">
        <span class="legend-dot double" aria-hidden="true"></span>
        {{ dictionaryService.get('Double Visit') }}
      </span>

      <span class="legend-item">
        <span class="legend-dot workshop" aria-hidden="true"></span>
        {{ dictionaryService.get('Workshop') }}
      </span>

      <span class="legend-item">
        <span class="legend-dot triple" aria-hidden="true"></span>
        {{ dictionaryService.get('Triple Visit') }}
      </span>
    </div>

    <app-api-table
      [name]="name"
      [endpoint]="endpoint()"
      [hasIndexCol]="true"
    ></app-api-table>
  }
</app-tab-layout>
